import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Lock from '@/images/Lock.svg';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { useFormContext } from 'react-hook-form';
import { WebhookFormValues } from '../../../types';
import { isPrivateIp, isUrl } from '../../../utils/validations';
import { FieldLabel } from '../../common';
import { InputField } from '../../common/InputField';

const UrlFieldContainer = styled.div`
    display: flex;
    gap: 8px;

    > div {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
`;

const MethodField = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 136px;
    height: 40px;
    padding: 8px;
    flex-shrink: 0;

    border-radius: 8px;
    border: 1px solid ${theme.colors.black[300]};
    background: ${theme.colors.black[100]};

    color: ${theme.colors.secondary.main};
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.14px;
`;

export const UrlField = () => {
    const {
        register,
        formState: { errors },
    } = useFormContext<WebhookFormValues>();

    return (
        <UrlFieldContainer>
            <div>
                <FieldLabel label="Method" />
                <MethodField>
                    POST
                    <MaskedIcon src={Lock} size="16px" color={theme.colors.black[700]} />
                </MethodField>
            </div>

            <div style={{ width: '100%' }}>
                <FieldLabel label="URL" />
                <InputField
                    placeholder="https://api.company.com/hook"
                    inputProps={{
                        ...register('url', {
                            required: 'Must have a URL',
                            validate: {
                                hasValidScheme: value =>
                                    value.startsWith('http://') ||
                                    value.startsWith('https://') ||
                                    'URL must start with http:// or https://',
                                isUrl: value => isUrl(value) || 'Please enter a valid URL',
                                notPrivateIp: value => !isPrivateIp(value) || 'Private network URLs aren’t supported.',
                            },
                            maxLength: {
                                value: 1000,
                                message: 'URL is too long.',
                            },
                        }),
                    }}
                    error={!!errors.url}
                    helperText={errors.url?.message}
                />
            </div>
        </UrlFieldContainer>
    );
};
